export const clearDataLayer = () => {
    if (typeof window === 'undefined') {
        return;
    }

    window.dataLayer = [];
    window.dataLayer.push({ecommerce:null}); 
} 
